<div class="card">
   <div class="panel-head">
      <h3>Scheduled Meetings</h3>
      <div class="spacer"></div>
   </div>

   <div
      class="section-loader"
      *ngIf="isLoading; else content">
      <div class="simple-spinner"></div>
   </div>

   <ng-template #content>
       <div
          class="nm"
          *ngIf="nextMeeting; else noMeetings"
          (click)="readOnly ? null : openDetail(nextMeeting)"
          [style.cursor]="readOnly ? 'default' : 'pointer'">
         <div>
            <div class="nm-title">
               <span class="nm-lbl">Next Meeting:</span>
               {{ nextMeeting.meetingSubject }}
               <span *ngIf="nextMeeting.isRecurring" class="material-icons" style="font-size: 14px; color: #2e7d32; margin-left: 4px;" title="Recurring meeting">repeat</span>
            </div>
            <div class="nm-k">Location</div>
            <div class="nm-loc">{{ nextMeeting.hospitalName }}</div>
            <div class="nm-meta">
               <span class="material-icons">schedule</span>
               {{ nextMeeting.startTime }} - {{ nextMeeting.endTime }}
               <span *ngIf="nextMeeting.timeZone">({{ nextMeeting.timeZone }})</span>
            </div>
            <div class="nm-meta">
               <span class="material-icons">calendar_today</span>
               {{ nextMeeting.scheduledDate | date: "MM/dd/yyyy" }}
            </div>
         </div>
         <div class="nm-dur">
            <div class="nm-k">Duration</div>
            <div class="v">{{ nextMeeting.duration }}</div>
         </div>
          <div>
             <button
                class="join-btn"
                *ngIf="!readOnly"
                (click)="join(nextMeeting)">
                <span class="material-icons">videocam</span>
                Join
             </button>
          </div>
          
       </div>

       <ng-template #noMeetings>
          <p class="empty-hint">No upcoming meetings scheduled.</p>
       </ng-template>

       <ng-container *ngIf="upcomingMeetings.length">
          <div
             class="acc-row"
             [class.open]="upcomingOpen"
             (click)="upcomingOpen = !upcomingOpen">
             <span class="acc-plus">{{ upcomingOpen ? "−" : "+" }}</span>
             <b>Upcoming Meetings</b>
             <span class="cnt-pill green">{{ upcomingMeetings.length }}</span>
          </div>
          <div
             class="acc-body"
             [class.open]="upcomingOpen">
              <div
                class="mtg-row"
                *ngFor="let m of upcomingMeetings"
                (click)="readOnly ? null : openDetail(m)"
                [style.cursor]="readOnly ? 'default' : 'pointer'">
                <span class="bar-g"></span>
                <span *ngIf="m.isRecurring" class="material-icons" style="font-size: 12px; color: #2e7d32; margin-right: 4px;" title="Recurring meeting">repeat</span>
                <span class="d">{{ m.scheduledDate | date: "EEEE, MMMM d, y" }}</span>
                <span class="t">{{ m.startTime }}</span>
             </div>
          </div>
       </ng-container>
       
       <div class="addmeeting" *ngIf="!readOnly" (click)="onAddMeeting()">+ Add a meeting</div>
   </ng-template>
</div>
